import { Landmark, MessageCircle } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { openChat } from "../../lib/api";

const items = [
  ["Influence & rayonnement", "Travaux pour asseoir votre autorité, votre image et votre présence auprès du public."],
  ["Protection politique", "Protection contre la jalousie, les envoutements et les ennemis déclarés ou cachés."],
  ["Victoire & faveur du public", "Rituels de force et de faveur pour les campagnes, les scrutins et les grandes échéances."],
];

export const Politicians = () => (
  <section id="politiciens" className="relative overflow-hidden bg-[#12100e] py-24 md:py-36" data-testid="politicians-section">
    <div className="pointer-events-none absolute -right-40 bottom-0 h-[460px] w-[460px] rounded-full bg-amber-500/10 blur-[130px]" />
    <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-5 md:px-10 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Reveal><Eyebrow>Cercle privé</Eyebrow></Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl leading-tight text-amber-50 sm:text-4xl lg:text-5xl">
            Travaux pour les Politiciens
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-base leading-relaxed text-stone-300 md:text-lg">
            Hommes et femmes politiques : le Maître Wouffa vous accompagne en secret. Présentez votre situation
            dans la discussion instantanée — identités et échanges restent strictement confidentiels, rien ne sort
            jamais de ce site.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <button onClick={() => openChat("Bonjour Maître, je suis intéressé par un travail pour les politiciens. Ma situation est : ")}
            data-testid="politicians-chat-button"
            className="mt-10 flex items-center gap-3 rounded-full border border-amber-500/60 px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] text-amber-200 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
            <MessageCircle className="h-4 w-4" /> Discuter en privé
          </button>
        </Reveal>
      </div>
      <div className="flex flex-col gap-4 lg:col-span-6">
        {items.map(([title, txt], i) => (
          <Reveal key={title} delay={0.1 * i}>
            <div className="flex items-start gap-5 rounded-2xl border border-amber-900/40 bg-[#181512] p-6 md:p-8" data-testid={`politician-item-${i}`}>
              <span className="font-display text-3xl text-amber-500/60">0{i + 1}</span>
              <div>
                <Landmark className="mb-3 h-5 w-5 text-amber-400" />
                <p className="font-serif-it text-2xl italic text-amber-100">{title}</p>
                <p className="mt-2 text-sm leading-relaxed text-stone-300">{txt}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
